/* global ApplePaySession */

import React, {useState,useContext,useRef,useEffect} from "react";

import { useNavigate  } from "react-router-dom";
import Lang from '../../../lang/translations';
import helpers from "../../../_helpers/helpersFunction";
import PopupGenerico from '../../../popup/popupGenerico';
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import {Helmet} from "react-helmet";

import Context from '../../../context/context';

const config = require("../../../_helpers/configServizi"); 


export default function Mollie(props) {

        let navigate = useNavigate();
        const context = useContext(Context)
    
        const domain = window.location.hostname;


        useEffect(() => {
         
        }, []);
      

        async function creaIntentoDiPagamento() {

            const d = new Date();

            helpers.logToBackend("Tentativo mollie",{pixel:true,clickid:localStorage.getItem('trackerId'),et:"tentativo"})
            
            const data = {
                country : helpers.getCountry(),
                rateplan : context.rateplanScelto,
                descriptor : config.servizi[domain].descriptor,
                payment_company : config.servizi[domain].payment_company,
                city : localStorage.getItem("city"),
                clickid : localStorage.getItem("trackerId"),
                domain : window.location.hostname,
                paySource : "CREDITCARD",
                email : context.email,
                newCard : context.newCard,
                actonfile : false,
                userAgent: navigator.userAgent,
                pacchettone: context.flusso.rateplans?.pacchettone?.id
            }    



            const response = await tryChargeMollie(data);
   
            if (response["_links"].checkout) {

              window.location.href = response["_links"].checkout.href;
              
            } else {
                const contenuto = helpers.contenuto_popop_pagamento(response.message)
                helpers.showPopupgenerico("blocked",context,contenuto)
            }
        }



        async function tryChargeMollie(dati){
            var token = localStorage.getItem('token');
            try{
          
              return await fetch(process.env.REACT_APP_PAY+"/orders/mollie/createPayment",{ 
                method: 'post', 
                headers: {
                  'Accept': 'application/json, text/plain, */*',
                  'Content-Type': 'application/json',
                  'Authorization': 'Bearer '+ token
                },
                body: JSON.stringify(dati)
              })
              .then(res => res.json())
              .then(response => {
                return response
              })
              .catch((err)=>{
                 helpers.logToBackend("tryCharge 1",{clickid:dati.clickid,error:err.message})
              })
            }catch(err){
               helpers.logToBackend("tryCharge try catch",{clickid:dati.clickid,error:err.message})
            }
          }
        
     
        return (<>
                    <button className="btn btn-block choose" onClick={()=>{creaIntentoDiPagamento(); }}><div>{Lang( {"w": "carta","page": "creditCardForm"} )}<img style={{marginLeft:"10px"}} src="/img/method_hpp.png"></img></div></button>
                </>)
 

  
}